import * as React from 'react'
import * as ReactDOM from 'react-dom'
import Main from './Main'
import {store} from './core/redux/reducer'
import {Provider} from 'react-redux'
import CssBaseline from '@material-ui/core/CssBaseline'
import {createGenerateClassName} from '@material-ui/core'
import JssProvider from 'react-jss/lib/JssProvider'

const generateClassName = createGenerateClassName({
  productionPrefix: 'arkea-front',
});

ReactDOM.render(
  <Provider store={store}>
    <JssProvider generateClassName={generateClassName}>
      <div>
        <CssBaseline/>
        <Main/>
      </div>
    </JssProvider>
  </Provider>,
  document.getElementById('react-dashboard') as HTMLElement
)



// WEBPACK FOOTER //
// ./src/index.tsx